import { gql } from '@apollo/client';

export const UPDATE_ELEMENT = gql`
  mutation updateElement($updateInput: UpdateElementInput!) {
    updateElement(updateElementInput: $updateInput) {
      id
    }
  }
`;

export const UPDATE_ELEMENT_DISPLAY = gql`
  mutation updateElementDisplay($updateInput: UpdateElementDisplayInput!) {
    updateElementDisplay(updateElementDisplayInput: $updateInput) {
      id
    }
  }
`;
